// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"f47498ab","573":"f957842c","583":"f957842c","635":"f957842c","719":"550055c0"}[chunkId] + ".chunk.css";
};